// extracted by mini-css-extract-plugin
export default {"l":"_654b26395a"};